module.exports = __webpack_public_path__ + "img/app_vue_phone.8e1b3006.png";